import React from "react";

import { cn } from "@/lib/utils";

/* Applies a consistent layout to content blocks.
 * To be used within a `Section` component (components/ui/section.tsx) to normalise outer spacing.
 */

export function Container({
  className,
  ...props
}: React.HTMLAttributes<HTMLElement>) {
  return (
    <div
      className={cn(
        "container grid grid-cols-4 gap-x-2 sm:gap-x-4 md:grid-cols-12",
        className
      )}
      {...props}
    />
  );
}
